/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import {
    NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef,
    HostListener, SimpleChanges, ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { SharedDataCache } from '../../core/common/shared.data';
// NGC
import { NgcI18NModule } from '../i18n/ngc-i18n.component';
import { NgcErrorModule } from '../error/ngc-error.component';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcLabelInputComponent),
    multi: true
};

/**
 * Label Input
 */

export class NgcLabelInputComponent extends ControlComponent {
    private _label: string = null;
    //

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * Value
     */
    
    set label(label: string) {
        if (this._label !== label) {
            this._label = label;
            this.modelUpdated(this._label);
        }
    }

    /**
     * Gets Value
     */
    get label() {
        return this._label;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-labelinput',
    template: `
            <div *ngIf="visible" class="group inline-label">
                <input type="text" [(ngModel)]="value">
                <label><ngc-i18n [value]="_label"></ngc-i18n></label>
            </div>
            <ngc-error *ngIf="visible" [value]="error"></ngc-error>
            `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input, args: ["label", ] },],
};
}

/**
 * Label Input Module
 */

export class NgcLabelInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgcI18NModule, NgcErrorModule],
    exports: [NgcLabelInputComponent],
    declarations: [NgcLabelInputComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
